(function () {
    'use strict';

    angular
        .module('app')
        .controller('ShowEntityTemplateUsageDialogCtrl', ShowEntityTemplateUsageDialogCtrl);

    ShowEntityTemplateUsageDialogCtrl.$inject = ['DialogInstance', 'EntityTemplatesService', 'entityTemplateIds'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog showing the usage of the entity templates
     * 
     * @param {int} entityTemplateIds - Ids of entity templates for which the usage is to be shown.
     */
    function ShowEntityTemplateUsageDialogCtrl(DialogInstance, EntityTemplatesService, entityTemplateIds) {
        /* jshint validthis:true */
        var vm = this;
        vm.allEntityTemplateCountsSelected = true;
        vm.loading = true;
        vm.ok = ok;

        activate();

        function activate() {
            getUsage().finally(function () {
                vm.loading = false;
            });
        }

        function getUsage() {
            return EntityTemplatesService.getItemCount(entityTemplateIds)
                            .then(getItemCountOk)
                            .catch(getItemCountError);

            function getItemCountOk(response) {
                vm.entityTemplateCounts = response;
            }

            function getItemCountError(response) {
                if (response.status === 404) {
                    vm.entityTemplateNotFound = true;
                }

                vm.error = true;
            }
        }

        function ok() {
            DialogInstance.ok();
        }
    }
})();
